export default "__VITE_ASSET__OpTps5Q$__"